export default __webpack_public_path__ + "c6264a3160bd228d90d77bfdea8db778.png";